import React from 'react';
import Layout from '../components/Layout';
import { Link } from "react-router-dom";


const Account = () => {
    
    return ( 
        
        <Layout title="About" description="This is the About page" >
            <div className="container">
              <div className="text-center mt-5" >
                <form>
                  <div className="form-group">
                    <label >Adresse Mail</label>
                    <input type="email" className="form-control" autoComplete="user-name" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Entrez votre mail"/>
                    <small id="emailHelp" className="form-text text-muted">Nous n'utiliserons pas vos donéees personnelles.</small>
                  </div>
                  <div className="form-group">
                    <label >Mot de passe</label>
                    <input type="password" className="form-control" id="exampleInputPassword1" autoComplete="current-password" placeholder="Mot de passe"/>
                  </div>
                  <div className="form-group form-check">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1"/>
                    <label className="form-check-label" >Je ne suis pas un robot.</label>
                  </div>
                  <Link to='/accountpage'><button type="submit" className="btn btn-primary">Valider</button></Link>
                </form>
              </div>
            </div>
        </Layout>
     );
}
 
export default Account;